module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0114.jpg?v=e325f9cc";